import { render } from "./concern-person-info-update.vue?vue&type=template&id=09856319&scoped=true"
import script from "./concern-person-info-update.vue?vue&type=script&lang=js"
export * from "./concern-person-info-update.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css&external"
import "./concern-person-info-update.vue?vue&type=style&index=1&id=09856319&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09856319"]])

export default __exports__